import UserThumbnail from '@/components/UserThumbnail'
import { clsxMerge } from '@/helpers/utilities'
import { Asset } from '@/types/assets'

export function NftDetails({ asset, className }: { asset: Asset; className?: string }) {
  return (
    <dl
      className={clsxMerge(
        'divide-y divide-gray-200 border-b border-t border-gray-200 dark:divide-gray-800 dark:border-gray-800',
        className
      )}
    >
      <div className="flex justify-between py-3 text-sm font-medium">
        <dt className="text-gray-500">Asset ID</dt>
        <dd className="text-gray-900 dark:text-gray-100">{asset.id}</dd>
      </div>
      <div className="flex justify-between py-3 text-sm font-medium">
        <dt className="text-gray-500">Unit Name</dt>
        <dd className="text-gray-900 dark:text-gray-100">{asset.unitName}</dd>
      </div>
      <div className="flex items-center justify-between py-3 text-sm font-medium">
        <dt className="text-gray-500">Creator</dt>
        <dd className="text-gray-900 dark:text-gray-100 max-w-[75%] xs:max-w-[80%] sm:max-w-[16rem] flex items-center justify-end pl-2">
          <UserThumbnail
            address={asset.creator}
            size="sm"
            textColor="text-gray-900 group-hover:text-brand-500 dark:text-gray-100"
            fallbackClassName="text-gray-900 truncate dark:text-gray-100"
            wrapperClassName="min-w-0 flex items-center"
            staleTime={Infinity}
          />
        </dd>
      </div>
    </dl>
  )
}
